<template>
  <div>
      <div id="myChart1">
        <van-loading v-if="isLoading" />
      </div>
  </div>
</template>

<script>
export default {
  name: 'moreLineEcharts',
  data() {
    return {
      isLoading: true,
      title: '', // 图表标题
      statisticsDays:[],
      yAxisMax : 5,
      zMaxValue : 0
      // res: {
      //   '24/09':[320, 332, 301, 334, 390],
      //   '24/10':[220, 182, 191, 234, 290],
      //   '24/11':[150, 232, 201, 154, 190],
      //   '24/12':[98, 77, 101, 99, 40],
      //   '25/01':[320, 332, 301, 334, 390]
      // },
    }
  },

  async created() {
  },
  async mounted() {
  },
  methods: {
    init(data){
      var that = this
      if(data){
        this.statisticsDays = data.dates
        const series = []
        Object.keys(data.data).forEach(key => {
          series.push({
            name: key,
            type: 'bar',
            barGap: 0,
            emphasis: {
              focus: 'series'
            },
            barWidth: 9,
            data: data.data[key]
          })
          that.zMaxValue = Math.max(...data.data[key].filter(value => value !== 0));
          that.yAxisMax = Math.max(that.yAxisMax,that.zMaxValue)
        });
        this.drawLine(series)
      }
    },
    drawLine(series) {
      // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
      const myChart1 = this.$echarts.init(document.getElementById('myChart1'))

      const option = {
        // 设置图标距离四周的距离
        grid: {
          top: 40,
          left: 40, // 调整这个属性
          right: 20,
          bottom: 35
        },
        color: ['#5E8DFA', '#44D4FA', '#67F190'],
        tooltip: {},
        xAxis: [{
            type: 'category',
            axisTick: { show: false },
            data: this.statisticsDays
          }
        ],
        yAxis: [{
            max: this.yAxisMax,
            type: 'value',
            name:"单位：（条）"
          }
        ],
        series: series
      }
      myChart1.setOption(option)
      this.isLoading = false
    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose();
      }
    }
  }
}
</script>
<style lang="less" scoped>
#myChart1 {
  width: 100%;
  height: 260px;
  padding: 0px;
  background: #fff;
}
</style>
